import azureDevOpsService from './azureDevOpsService';

const BASE = '/api/buglinks';

function authHeaders() {
  const pat = azureDevOpsService.getPat();
  return pat ? { 'X-Azure-Devops-Pat': pat } : {};
}

// Fallback de liaison bug <-> test quand il n'existe pas de Work Item "Test Case"
// ADO à rattacher (ex: tests Robot Framework sans jumeau ADO). Stocké côté app, par build.
const bugLinkService = {
  async getForBuild(pipelineId, buildId) {
    const res = await fetch(`${BASE}?pipelineId=${pipelineId}&buildId=${buildId}`, {
      headers: authHeaders()
    });
    if (!res.ok) throw new Error('buglinks fetch failed');
    const data = await res.json();
    const map = {};
    for (const entry of Object.values(data)) {
      if (entry.bugs?.length) map[entry.testName] = entry.bugs;
    }
    return map;
  },

  async add({ pipelineId, buildId, testName, bug }) {
    const res = await fetch(BASE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify({ pipelineId, buildId, testName, bug })
    });
    if (!res.ok) throw new Error('buglinks add failed');
    return res.json();
  }
};

export default bugLinkService;
